import { useNavigate } from 'react-router-dom';
import Typography from '../Typography/Typography';
import styles from './style.module.css';

export interface Column<T> {
  title: React.ReactNode;
  key: keyof T;
}

interface TableProp<T extends { id: string | number }> {
  header: Column<T>[];
  data: T[];
  className?: string;
  route?: string;
}

export const OrderTable = <T extends { id: string | number }>({
  header,
  data,
  className,
  route,
}: TableProp<T>) => {

  const navigate = useNavigate()

  const routing = (id: string) => {
    if (route) {
      navigate(`${route}/${id}`)
    } else {
      return ""
    }
  }

  return (
    <div className={`${styles.tableContainer}${className ? " " + className : ""}`}>
      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              {header.map((col) => (
                <th key={String(col.key)}>
                  <Typography className={styles.headerText}>
                    {col.title}
                  </Typography>
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {data.map((item) => (
              <tr
                key={item.id}
                onClick={() => { routing(`${item.id}`) }}
                className={styles.navRow}
              >
                {header.map((col) => (
                  <td key={String(col.key)}>
                    {/* <Link to={}> */}
                    <Typography className={styles.bodyText}>
                      {col.key === "id" ? `#${item[col.key]}` : (col.key === "price" ? `$${item[col.key]}` :item[col.key] as React.ReactNode)}
                    </Typography>
                    {/* </Link> */}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
